<template>
  <b-card-body class="p-2" v-if="isVisible">
    <ActionGroup
      :current-query="query"
      :options="options"
      :operators="operators"
      ref="actionGroup"
    />
  </b-card-body>
</template>

<script>
import ActionGroup from "@/own/components/customers/clients/actionBuilder/ActionGroup.vue";
export default {
  name: "ActionBuilder",
  components: {
    ActionGroup,
  },
  props: {
    query: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    operators: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      isVisible: true,
    };
  },
  methods: {
    addDefault() {
      this.$refs.actionGroup.addRule();
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-json-query-builder {
  font-size: 12px;
  user-select: none;
  * {
    font-size: 15px !important;
  }
  .vue-json-query-builder-header {
    cursor: pointer;
  }
}
</style>
